/**
 * Fixed-point helpers. The simulation stores no floating point numbers, because
 * float addition is not associative across engines and would desync replays.
 *
 * One tile = 1000 milli-tiles. All arithmetic below truncates toward zero,
 * which is the same on every JS engine.
 */

export const MILLI = 1000;

/** Whole tiles -> milli-tiles. */
export function toMilli(tiles: number): number {
  return Math.trunc(tiles * MILLI);
}

/** Milli-tiles -> whole tiles, truncated. */
export function toTiles(milli: number): number {
  return Math.trunc(milli / MILLI);
}

/** Integer multiply by a permille factor, e.g. mulPermille(1000, 600) === 600. */
export function mulPermille(value: number, permille: number): number {
  return Math.trunc((value * permille) / MILLI);
}

/** Integer division, truncated toward zero. Never produces -0. */
export function div(a: number, b: number): number {
  const r = Math.trunc(a / b);
  return r === 0 ? 0 : r;
}

/** Clamp an integer into [min, max]. */
export function clamp(value: number, min: number, max: number): number {
  return value < min ? min : value > max ? max : value;
}

/** Squared distance in milli-tiles. Used for range checks so no sqrt is needed. */
export function distSq(ax: number, ay: number, bx: number, by: number): number {
  const dx = ax - bx;
  const dy = ay - by;
  return dx * dx + dy * dy;
}
